import { Box, Stack, Typography } from "@mui/material";
// config
import colors from "../../../config/colors";

const RecentBrands = ({ brands = [] }) => {
  const filteredBrands = brands.filter((b) => b?.name !== "ATGPluginStore");
  if (!filteredBrands || filteredBrands.length === 0) return null;

  const displayBrands = filteredBrands.slice(0, 3);
  const brandNames = filteredBrands.map((brand) => brand?.name).join(", ");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 2,
      }}
    >
      <Stack direction="row" alignItems="center" sx={{ marginRight: 1 }}>
        {displayBrands.map((brand, index) => (
          <Box
            key={index}
            component="img"
            src={brand?.logo_url}
            alt={brand?.name}
            sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              marginLeft: index > 0 ? "-16px" : 0,
              zIndex: displayBrands.length - index,
              position: "relative",
            }}
          />
        ))}
      </Stack>
      <Stack direction="column" flex="1" flexWrap="wrap">
        <Typography fontSize={12} color={colors.gray200} lineHeight="20px">
          Recently partnered with brands like:
        </Typography>
        <Typography fontSize={12} fontWeight={500} lineHeight="20px">
          {brandNames}
        </Typography>
      </Stack>
    </Box>
  );
};

export default RecentBrands;
